module.exports = "<footer class=\"main-footer text-center\">\r\n    <strong>Copyright @ 2021 All Rights Reserved</strong>\r\n</footer>\r\n"